

const LeftSideBar = () => {
    return (
        <div className=" min-h-screen flex flex-row bg-primary-light">
            
        </div>
    )
}
export default LeftSideBar;